
import { TweenLite, Power0, Elastic} from "gsap";
import { AudioManager, Track } from "../../AudioManager";
import { MoneyFormatter } from "../../MoneyFormatter";
import { CSSResource } from "../../ResourceManager/CSSResource";
import { FontResource } from "../../ResourceManager/FontResource";
import { HTMLResource } from "../../ResourceManager/HTMLResource";
import { ImageResource } from "../../ResourceManager/ImageResource";
import { Resourceful, Resourceful2 } from "../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { Translator } from "../../Translator";
import { Size, SetStyles, CreateElement, Scale, AddTouchStartEventListener } from "../.././MyHelpers";
import { BigWinCountAnimation } from "../BigWinCountAnimation";
import { BonuRecoverStatus } from "../Bonus/SlotBonus";
import { SlotBonus2 } from "../Bonus/SlotBonus2";
import { SlotBonusParams } from "../Bonus/SlotBonusParams";
import { IBonusStartConfig, BonusFinish } from "../SlotGame";
import { CanvasSprite } from "../Sprite/CanvasSprite";
import { IWinLine } from "../WinLine";
import { FreegameMessages } from "./FreegameMessages";
import { FreegameSession } from "./FreegameSession";
import { FillingPotFeature, Settings } from "../../Settings";
import { Money } from "../../Money";
import { Bonus } from "../Bonus/Bonus";
import { PixiSpriteResource } from "../../ResourceManager/PixiSpriteResource";
import { ZIndex } from "../../ZIndex";
import { MyCanvas } from "../MyCanvas";
import { text } from "svelte/internal";
import { ISystemContext } from "../../Context/SystemContext";
import { ITimingContext } from "../../Context/TimingContext";
import { IRandomInterval } from "../../Context/RandomInterval";
import { FreegamesCommonConfiguration } from "../../api";
export interface FreegameBonus2Params extends SlotBonusParams {
	readonly gameName: string;
	readonly gameBonusResourcesBasePath: string;
	readonly commonBonusResourcesBasePath: string
	readonly viewSize: Size;
	readonly moneyFormatter: MoneyFormatter;
	readonly translator: Translator;
	readonly audio:AudioManager;
}

export class FreegameBonus2 extends SlotBonus2 implements Resourceful2 {

	protected view: HTMLElement = null;
	protected override resid: ResourceIdentifier;
	protected parentresid: ResourceIdentifier = null;

	//protected transition: SceneTransition = null;

	protected gameTitle: HTMLElement = null;

	//protected params: FreegameBonus2Params = null;
	protected gameResourcesBasePath: string;
	protected commonResourcesBasePath: string;
	protected viewSize: Size;

	protected session: FreegameSession = new FreegameSession();
	protected freeGamesTitleSprite: CanvasSprite = null;
	protected basepath: string = null;

	protected titleElement: HTMLElement = null;	

	protected moneyFormatter: MoneyFormatter = null;
	public translator: Translator;

	protected titleFreeGameContainer:HTMLElement;
	//Create  AUDIO 
	protected audio:AudioManager ;

	//finalWinContainer
	protected finalWinContainer : HTMLElement ; 

	protected titleGame: CanvasSprite ; 


	//Create stats container
	protected containerfreegameStats:HTMLElement=null;
	protected freegameStatsRight:HTMLElement=null;
	protected FreegamesPlayedValue:HTMLElement=null;
	protected TotalPlayed:HTMLElement=null;
	protected canvasFreegamesPlayedValue:MyCanvas;

	
	protected freegameStatsLeft:HTMLElement=null;
	protected freegamesNumValue:HTMLElement=null;
	protected FreegamesNumTitle:HTMLElement=null;
	protected canvasfreegamesLeftValue:MyCanvas;

	protected systemContext: ISystemContext = null;
	protected gameNameTimer : IRandomInterval;

	protected winConuntFrameSprite:CanvasSprite;

	protected winCanvasShow: MyCanvas = null;
	protected BonusWinSprite:CanvasSprite = null;

	protected statsFontHeight : number = Scale.X(110);
	protected labelFontHeight : number = Scale.X(80);
	protected winFontHeight : number = Scale.X(180);

	protected BonusName(): string
	{
		return "FreeGameBonus";
	}

	public constructor(gameResid: ResourceIdentifier, freegameConfig: FreegamesCommonConfiguration, params: FreegameBonus2Params) {
		super(params.gameName, params);

		this.parentresid = gameResid;
		this.resid = gameResid.Add(this.bonusName);
		this.translator = params.translator;
		//INI AUDIO
		this.audio=params.audio;
		//this.params = params;
		this.gameResourcesBasePath = params.gameBonusResourcesBasePath;
		this.commonResourcesBasePath = params.commonBonusResourcesBasePath;
		this.viewSize = params.viewSize;

		this.basepath = Settings.ResourcesFolder + "multigame/slot/" + params.gameName + "/";

		this.view = document.createElement("div");
		this.view.classList.add(this.resid.Scope());
		this.view.style.position = "absolute";
		this.view.style.top = "0px";
		this.view.style.left = "0px";
		this.view.style.width = this.viewSize.Width + "px";
		this.view.style.height = this.viewSize.Height + "px";		
		

		this.systemContext = params.systemContext.CreateSubContext("FreeGameBonus2");

		this.screenProtocol.AddReceiveMessageHandler(FreegameMessages.PickMessage.msgname, (m) => this.OnPick((<FreegameMessages.PickMessage>m).session), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(FreegameMessages.SpinMessage.msgname, (m) => this.OnSpin((<FreegameMessages.SpinMessage>m).session), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(FreegameMessages.PlusMessage.msgname, (m) => this.OnPlus((<FreegameMessages.PlusMessage>m).session), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(FreegameMessages.WinMessage.msgname, (m) => this.Win((<FreegameMessages.WinMessage>m).session), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(FreegameMessages.WinInterruptedMessage.msgname, (m) => this.WinInterrupt(), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(FreegameMessages.ShowWinContainer.msgname, (m) => this.ShowWin((<FreegameMessages.ShowWinContainer>m).session), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(FreegameMessages.ResetFinalContainerWin.msgname, (m) => this.ResetShowWin((<FreegameMessages.ResetFinalContainerWin>m).session), this.screenProtocolScope);
		this.moneyFormatter = params.moneyFormatter;
		this.systemContext = params.systemContext.CreateSubContext("FreeGameBonus2")		
	}

	public async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
		//// Log.Debug(this.logGroup, this.)
		//resourceManager.Add(new HTMLResource(this.commonResourcesBasePath + "FreegameBonus.2.html", this.resid.ScopedResourceName("html")));
		//resourceManager.Add(new CSSResource(this.commonResourcesBasePath + "FreegameBonus.2.css", this.resid.ScopedResourceName("css"), this.parentresid.CSSScope()));

		//resourceManager.AddGlobal(new SpriteResource(this.gameResourcesBasePath + "transition", this.resid.Add("transition").Shared(), true, this.logGroup.Add("transition"), true));
		//resourceManager.Add(new ImageResource(this.gameResourcesBasePath + "background.2.jpg", this.resid.ScopedResourceName(["background2", "image"])));
		await this.PrepareFonts(resourceManager);
		//LOAD AUDIO
		await this.AudioPrepare(resourceManager);

		await this.TitlePrepare(resourceManager);

		//prepare sprites for win container
		await this.spritesWinContainer(resourceManager);
	}

	public spritesWinContainer(resourceManager: IWriteOnlyResourceManager){
		resourceManager.AddGlobal(new SpriteResource(this.gameResourcesBasePath + "ValueContainer", ResourceIdentifier.Global.Add("BigSymbolFreegames").Add(this.gameName+"ValueContainer"), true, this.logGroup.Add(this.gameName), true));
		resourceManager.Add(new SpriteResource(this.commonResourcesBasePath + "resources/frameSprite", this.resid.Add("frameSprite"), true, this.logGroup.Add("frameSprite"), true));
	}

	public AudioPrepare(resourceManager: IWriteOnlyResourceManager):void
	{
		//LOAD LIGHTING
		this.audio.AddTrack(new Track(this.commonResourcesBasePath + "resources/tracks/WinCount" + Settings.audioFormat, this.resid.ScopedResourceName("WinCount")));
	}

	protected async PrepareFonts(resourceManager: IWriteOnlyResourceManager): Promise<void>
	{	
		resourceManager.Add(new FontResource(this.commonResourcesBasePath + "resources/newzone.ttf", this.resid.ScopedResourceName("bigwincount")));
	}

	public async TitlePrepare(resourceManager: IWriteOnlyResourceManager) : Promise<void>
	{
		
		//resourceManager.Add(new ImageResource(this.basepath + "resources/title.png", this.resid.ScopedResourceName(["title", "image"])));
		if(Settings.fillingPotFeature == FillingPotFeature.Disable)
		resourceManager.Add(new PixiSpriteResource(this.gameResourcesBasePath + "title_sprite2", this.resid.Add(this.gameName).Add("title"), true, this.logGroup.Add("title-"+this.gameName), true));
		resourceManager.AddGlobal(new SpriteResource(this.commonResourcesBasePath + "resources/freegameTitle", ResourceIdentifier.Global.Add("freegametitle"), true, this.logGroup.Add("freegametitle"), true));
		resourceManager.AddGlobal(new SpriteResource(this.commonResourcesBasePath + "resources/BonusWin", ResourceIdentifier.Global.Add("bonusWin-Title").Add("classic-FreeGamesBonus"), true, this.logGroup.Add("bonusWin-Title"), true));
	}

	public GameTitleLoaded(resourceManager: IReadOnlyResourceManager)
	{
		this.titleElement = CreateElement("div", {classes:["game-title"], parentToAppend: this.view, 
		style:
		{
			position:"relative",
			top: Scale.Ypx(0),
			//left: Scale.Xpx(0),
			width: Scale.Wpx(1000),
			height: Scale.Hpx(500),
			//zIndex:ZIndex.BonusCofirmMessage.toString()
			display : "flex",
			alignContent : "center",
			justifyContent : "center",
			margin : "auto",
			zIndex:ZIndex.freegameStats2.toString(),

		}
	});
		
		this.titleGame = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add(this.gameName).Add("title")).sprite, canvasSize: new Size(1000, 500)});	
		this.titleElement.appendChild(this.titleGame.View());	
		this.gameNameTimer = this.systemContext.TimingContext().CreateRandomInterval("TitleGameFreeGames", 1500,6000, () => this.titleGame.Start(false));
		
		
	}

	public CreateFreeGameTitleSprite(resourceManager: IReadOnlyResourceManager){
		this.titleFreeGameContainer = document.createElement("div");
		this.titleFreeGameContainer.classList.add("titleFreeGameContainer");
		this.titleFreeGameContainer.style.setProperty("id","titleFreeGameContainer");
		this.titleFreeGameContainer.style.setProperty("class","titleFreeGameContainer");		
		this.titleFreeGameContainer.style.display="flex";
		this.titleFreeGameContainer.style.position="relative";
		this.titleFreeGameContainer.style.justifyContent = "center";
		this.titleFreeGameContainer.style.zIndex=ZIndex.freegameStats2.toString();
		//this.titleFreeGameContainer.style.top=Scale.Xpx(0);
		this.freeGamesTitleSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("freegametitle")).sprite, canvasSize: new Size(Scale.W(1000),Scale.H(150))});
		this.freeGamesTitleSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("WinCount")));
		//this.titleSprite.View().style.display = "flex";
		this.titleFreeGameContainer.appendChild(this.freeGamesTitleSprite.View());
		this.view.appendChild(this.titleFreeGameContainer)
		this.freeGamesTitleSprite.Update();
	}


	public async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
		//this.view.innerHTML = resourceManager.Get<HTMLResource>(this.resid.ScopedResourceName("html")).html;
		//this.view.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background2", "image"])).CssBackground();
		if (Settings.fillingPotFeature == FillingPotFeature.Disable) {
			await this.GameTitleLoaded(resourceManager);
			await this.CreateFreeGameTitleSprite(resourceManager);
		}
		await this.createFreeGameStats(resourceManager);
		await this.createWinCount(resourceManager);	
	}

	protected createWinCount(resourceManager: IReadOnlyResourceManager){
		this.finalWinContainer = CreateElement("div", {
			classes: ["win-contianer"], parentToAppend: this.view,
			style: {
				height : Scale.Hpx(1000),
				width: Scale.Wpx(1920),
				top: Scale.Ypx(0),
				//left: this.viewSize.width + "px",
				textAlign: "center",
				color: "yellow",
				position: "absolute",
				zIndex:ZIndex.freegameStats2.toString(),
				margin : "auto",
				display:"none",
			}
		});

		this.BonusWinLoaded(resourceManager);

		let BackgroundContainer = CreateElement("div", {
			parentToAppend: this.finalWinContainer,
			style: {
				backgroundColor: "rgba(0,0,0,0.7)",
				width: Scale.Wpx(1590),
				height: Scale.Hpx(347),
				//position: "relative",
				margin:"auto",
				//display:"flex",				
				//top: Scale.Ypx(423),
				//left: Scale.Xpx(63),

			}
		});

		//CHANGE TO SPRITE 
		let sprite = resourceManager.Get<SpriteResource>(this.resid.Add("frameSprite")).sprite;
		this.winConuntFrameSprite = new CanvasSprite({sprite: sprite, canvasSize: new Size(Scale.W(1720), Scale.H(500))});
		sprite = null;
		//this.winConuntFrameSprite.ScaleNonUniform(1,1.3);
		//this.winConuntFrameSprite.View().style.zIndex="4";
		this.winConuntFrameSprite.View().style.position = "relative";
		this.winConuntFrameSprite.View().style.top = Scale.Ypx(-413);
		//this.winConuntFrameSprite.View().style.display="none";
		this.winConuntFrameSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("WinCount")));
		this.finalWinContainer.appendChild(this.winConuntFrameSprite.View());	
		this.CanvaswinCountShow(resourceManager);	
	}

	protected BonusWinLoaded(resourceManager: IReadOnlyResourceManager)
	{
		this.BonusWinSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("bonusWin-Title").Add("classic-FreeGamesBonus")).sprite, canvasSize: new Size(Scale.W(1920),Scale.H(339))});
			//this.TitleFreeGameSprite.Start(true);
		this.BonusWinSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("BounceSound")));
		this.BonusWinSprite.View().style.display="flex";
		this.BonusWinSprite.View().style.position = "relative";
		this.finalWinContainer.appendChild(this.BonusWinSprite.View());
	}

	protected CanvaswinCountShow(resourceManager: IReadOnlyResourceManager)
	{
		this.winCanvasShow = new MyCanvas(new Size(Scale.W(1575), Scale.H(300)), {
            style: {
                top:Scale.Ypx(-818),
                //left:Scale.Xpx(61),
                position: "relative",
                alignItems: "center",
                justifyContent: "center",
                zIndex: ""+ ZIndex.BonusWin,
            }
        });
		this.finalWinContainer.appendChild(this.winCanvasShow.View());	
		this.SetTextCanvas("?",this.winCanvasShow,this.winFontHeight);	
	}

	
	
	
		
	protected createFreeGameStats(resourceManager: IReadOnlyResourceManager):void{
		//let freegameStats: HTMLElement = this.view.querySelector(".freegame-stats");
		this.containerfreegameStats = CreateElement("div",{classes:["freegame-stats"],parentToAppend : this.view , 
		style:{
			display: "flex",
				position: "absolute",
				width: "100%",
				height: "40%",
				//bottom: "0px",
				fontSize:"1em",
				flexDirection :"row",
				zIndex:ZIndex.freegameStats2.toString(),
				top : Scale.Ypx(644),
		}});
		this.FreeGameStatsLeft(resourceManager);
		this.FreeGameStatsRight(resourceManager);
	}

	protected textPlayedCanvas:MyCanvas;
	protected FreeGameStatsRight(resourceManager: IReadOnlyResourceManager){
		this.freegameStatsRight = CreateElement("div", {
			classes: [this.resid.Scope() + "-freegameStatsRight"],
			style: {
				position: "relative",
				right: Scale.Xpx(0),
				//width: Scale.Wpx(422),
				height: "100%",
				//top: Scale.Ypx(415),
				display: "flex",
				justifyContent: "center",
				alignContent: "center",
				flexDirection:"column",
				margin:"auto",
				zIndex: ZIndex.freegameStats2.toString(),
				alignItems:"center",
			}
		});
		this.spinsPlayedSprite(resourceManager);

		this.FreegamesPlayedValue = CreateElement("div", {
			classes: [this.resid.Scope()+"-freegames-right-value","freegames-played-num-value"],
			parentToAppend:this.freegameStatsRight,
			style: {
				position: "absolute",
				//left:Scale.Xpx(0),
				top:Scale.Xpx(55),
				//width:Scale.Xpx(460),
				display:"flex",
				
			}
		});

		this.canvasFreegamesPlayedValue = this.createWinCountCanvas();
		this.SetTextCanvas("?",this.canvasFreegamesPlayedValue,this.statsFontHeight);
		this.FreegamesPlayedValue.appendChild(this.canvasFreegamesPlayedValue.View());

		this.TotalPlayed = CreateElement("div", {
			classes: [this.resid.Scope() + "-total-played"],
			parentToAppend: this.freegameStatsRight,
			style: {
				position: "relative",
				top:Scale.Xpx(-56),
				//lineHeight:Scale.fhpx(77),
				fontSize:Scale.fh(4.5)+"em",
				fontFamily:this.resid.ScopedResourceName("font"),				
				color:"yellow",
				textAlign:"center",
				alignItems:"center",
				alignContent:"center",
				alignSelf:"center",
				//margin:Scale.XYpx(25),
				//zIndex:ZIndex.freegameStatsRight.toString(),
				textShadow: `0px ${Scale.Xpx(10)} ${Scale.Ypx(10)} black, 0px 0px ${Scale.Ypx(10)} black, 0px 0px ${Scale.XYpx(20)} black`

			}
		});
		this.containerfreegameStats.appendChild(this.freegameStatsRight);	
		this.freegameStatsRight.appendChild(this.TotalPlayed);

		this.textPlayedCanvas = this.createTextInfoCanvas();
		this.SetTextCanvas(this.translator.t.played,this.textPlayedCanvas,this.labelFontHeight);
		this.translator.SetOnLanguageChangedCallback(() => this.SetTextCanvas(this.translator.t.played,this.textPlayedCanvas,this.labelFontHeight));
		this.TotalPlayed.appendChild(this.textPlayedCanvas.View());

		//this.spinsPlayedSprite(resourceManager);
	}
	protected textLeftCanvas:MyCanvas;
	protected FreeGameStatsLeft(resourceManager: IReadOnlyResourceManager)
	{
		this.freegameStatsLeft = CreateElement("div", {
			classes: [this.resid.Scope()+"-freegame-stats"],
			parentToAppend:this.containerfreegameStats,
			style: {
				display:"flex",
				position: "relative",
				//width:Scale.Wpx(422),
				height:"100%",
				//top:Scale.Ypx(415),
				zIndex:ZIndex.freegameStats2.toString(),
				left:Scale.Ypx(0),
				justifyContent:"center",
				flexDirection:"column",
				margin:"auto",
				alignItems:"center",
			}
		});

		this.spinsRemainingSprite(resourceManager);

		this.freegamesNumValue = CreateElement("div", {
			classes: [this.resid.Scope()+"-freegames-left-value","freegames-num-value"],
			parentToAppend:this.freegameStatsLeft,
			style: {
				position: "absolute",
				//left:Scale.Xpx(0),
				top:Scale.Xpx(55),
				// width:Scale.Xpx(460),
				display:"flex",
				
			}
		});
		
		this.canvasfreegamesLeftValue = this.createWinCountCanvas();		
		this.SetTextCanvas("?",this.canvasfreegamesLeftValue,this.statsFontHeight);
		this.freegamesNumValue.appendChild(this.canvasfreegamesLeftValue.View());

		this.FreegamesNumTitle = CreateElement("div", {
			classes: [this.resid.Scope()+"-freegames-left-title"],
			parentToAppend:this.freegameStatsLeft,
			style: {
				position: "relative",
				top:Scale.Xpx(-56),
				//lineHeight:Scale.fhpx(77),
				fontSize:Scale.fh(4.5)+"em",
				fontFamily:this.resid.ScopedResourceName("font"),				
				color:"yellow",
				textAlign:"center",
				alignItems:"center",
				alignContent:"center",
				alignSelf:"center",
				//margin:Scale.XYpx(25),
				textShadow: `0px ${Scale.Xpx(10)} ${Scale.Ypx(10)} black, 0px 0px ${Scale.Ypx(10)} black, 0px 0px ${Scale.XYpx(20)} black`
			}
		});

		this.textLeftCanvas = this.createTextInfoCanvas();
		this.SetTextCanvas(this.translator.t.totalleftHoldAndSpin,this.textLeftCanvas,this.labelFontHeight);
		this.translator.SetOnLanguageChangedCallback(() => this.SetTextCanvas(this.translator.t.totalleftHoldAndSpin,this.textLeftCanvas,this.labelFontHeight));
		this.FreegamesNumTitle.appendChild(this.textLeftCanvas.View());	

		//this.spinsRemainingSprite(resourceManager);
	}

	//container for spins wins
	protected spinsPlayedBackgroundSprite: CanvasSprite = null;
	//container for spins left
	protected spinsRemainingBackgroundSprite:CanvasSprite=null;
	protected spinsRemainingSprite(resourceManager: IReadOnlyResourceManager)
	{
		this.spinsRemainingBackgroundSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("BigSymbolFreegames").Add(this.gameName+"ValueContainer")).sprite, canvasSize: new Size(Scale.W(550), Scale.H(450))});
		//this.spinsRemainingBackgroundSprite.Start(true);
		this.spinsRemainingBackgroundSprite.View().style.position="relative";
		this.spinsRemainingBackgroundSprite.View().style.left=Scale.Xpx(0);
		this.spinsRemainingBackgroundSprite.View().style.top=Scale.Ypx(10);
		this.freegameStatsLeft.appendChild(this.spinsRemainingBackgroundSprite.View());

	}

	protected spinsPlayedSprite(resourceManager: IReadOnlyResourceManager)
	{
		this.spinsPlayedBackgroundSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("BigSymbolFreegames").Add(this.gameName+"ValueContainer")).sprite, canvasSize: new Size(Scale.W(550), Scale.H(450))});
		//this.spinsPlayedBackgroundSprite.Start(true);
		this.spinsPlayedBackgroundSprite.View().style.position="relative";
		//this.spinsPlayedBackgroundSprite.Start(true);
		this.spinsPlayedBackgroundSprite.View().style.left=Scale.Xpx(0);
		this.spinsPlayedBackgroundSprite.View().style.top=Scale.Ypx(10);
		this.freegameStatsRight.appendChild(this.spinsPlayedBackgroundSprite.View());
		
	}

	protected createWinCountCanvas():MyCanvas{
		let canvas = new MyCanvas(new Size(Scale.W(300), Scale.H(200)), {
			style: {
				left: Scale.Xpx(0),
				top: Scale.Ypx(0),
				position: "relative",
				zIndex: ""+ ZIndex.BonusWin
			}
		});

		return canvas;
	}

	protected createTextInfoCanvas():MyCanvas{
		let canvas = new MyCanvas(new Size(Scale.W(600), Scale.H(150)), {
			style: {
				//left: Scale.Xpx(0),
				//top: Scale.Ypx(0),
				//position: "absolute",
				zIndex: ""+ ZIndex.freegameStats2
			}
		});

		return canvas;
	}

	protected SetTextCanvas(text: string, CanvasElement: MyCanvas, fontHeight: number) {
		CanvasElement.context.clearRect(0, 0, CanvasElement.size.Width, CanvasElement.size.Height);		
		CanvasElement.context.font = "bold " + fontHeight + "px " + this.resid.ScopedResourceName("bigwincount");
		let color: string = "orangered";
		let color2: string = "yellow";
		
		let gradient = CanvasElement.context.createLinearGradient(
			CanvasElement.size.Width / 2,
			CanvasElement.size.Height / 2 - fontHeight / 2,
			CanvasElement.size.Width / 2,
			CanvasElement.size.Height / 2 + fontHeight / 2
		);
		CanvasElement.context.lineJoin = "round"; //Experiment with "bevel" & "round" for the effect you want!
		CanvasElement.context.miterLimit = 2;
		// gradient.addColorStop(0, color);
		// gradient.addColorStop(0.70, color2);
		// gradient.addColorStop(1, color);
		gradient.addColorStop(0, color);
		gradient.addColorStop(0.25, color2);
		gradient.addColorStop(0.50, color2);
		gradient.addColorStop(0.75, color);
		gradient.addColorStop(1, color);
		CanvasElement.context.fillStyle = gradient;

		CanvasElement.context.textBaseline = "middle";
		CanvasElement.context.textAlign = "center";
		CanvasElement.context.strokeStyle = "black";
		CanvasElement.context.lineWidth = Scale.fh(22);
		CanvasElement.context.strokeText(text, (CanvasElement.size.Width / 2) , (CanvasElement.size.Height / 2));
		//CanvasElement.context.strokeStyle = "white";
		//CanvasElement.context.lineWidth = Scale.fh(22) / 4;
		//CanvasElement.context.strokeText(text, (CanvasElement.size.width / 2) , (CanvasElement.size.height / 2));
		CanvasElement.context.fillText(text, (CanvasElement.size.Width / 2), (CanvasElement.size.Height / 2));
		CanvasElement.RestoreContext();
		gradient = null;
		color = null;
		color2 = null;
	}

	/******
		
	******/

	public Prepare(bonusStartConfig: IBonusStartConfig)
	{

	}

	public Start(): void {
		if (this.session == null) {
			throw new Error("Session must not be null");
		}

	
		this.session.Reset();
		this.spinsRemainingBackgroundSprite.Start(true);
		this.spinsPlayedBackgroundSprite.Start(true);
		this.SetTextCanvas(this.session.played.toString(), this.canvasFreegamesPlayedValue, this.statsFontHeight);
		this.SetTextCanvas(this.session.left.toString(), this.canvasfreegamesLeftValue, this.statsFontHeight);	
		this.gameNameTimer?.Start();
	}



	public Update(): void {
		//this.transition.Update();
		this.freeGamesTitleSprite?.Update();
		this.titleGame?.Update();
		this.spinsPlayedBackgroundSprite.Update();
		this.spinsRemainingBackgroundSprite.Update();
		this.redrawCanasWinCount();
		this.winConuntFrameSprite.Update();
		this.BonusWinSprite.Update();
	}

	protected redrawCanasWinCount(){
		if (this.canvasFreegamesPlayedValue.WasContextLost()) {
			this.SetTextCanvas(this.session.played.toString(), this.canvasFreegamesPlayedValue, this.statsFontHeight);
		}
		if (this.canvasfreegamesLeftValue.WasContextLost()) {
			this.SetTextCanvas(this.session.left.toString(), this.canvasfreegamesLeftValue, this.statsFontHeight);
		}
		if(this.textPlayedCanvas.WasContextLost()){
			this.SetTextCanvas(this.translator.t.played,this.textPlayedCanvas,this.labelFontHeight);
		}
		if(this.textLeftCanvas.WasContextLost()){
			this.SetTextCanvas(this.translator.t.totalleftHoldAndSpin,this.textLeftCanvas,this.labelFontHeight);
		}
		if(this.winCanvasShow.WasContextLost()){
			this.SetTextCanvas(this.moneyFormatter.FormatCurrency(this.session.totalWin),this.winCanvasShow,this.winFontHeight);
		}
	}


	public View(): HTMLElement {
		return this.view;
	}

	public OnBonusFinish(bonusFinish: BonusFinish): void {
		this.spinsRemainingBackgroundSprite.Stop();
		this.spinsPlayedBackgroundSprite.Stop();		
	}
	public Hide(): void {
		this.view.style.visibility = "hidden";
		// console.log("Hide free game 2");
	}
	public Show(): void {
		this.view.style.visibility = "visible";
		// console.log("Show free game 2");
	}
	public Reset(): void {	
	}

	/*********
		SCREEN PROTOCOL EVENTS
	**********/

	protected OnPick(session: FreegameSession): void {
		if (session == null) {
			throw new Error("Session must not be null");

		}

		//this.transition.Start();
		this.session.Update(session);
		this.ApplySession();
	}


	protected OnSpin(session: FreegameSession): void {
		if (session == null) {
			throw new Error("Session must not be null");

		}
		this.session.Update(session);
		this.ApplySession();
	}
	protected OnPlus(session: FreegameSession): void {

		if (session == null) {
			throw new Error("Session must not be null");
		}
		this.session.Update(session);
		this.ApplySession();
		this.freeGamesTitleSprite?.Start(false);
	}

	protected Win(session: FreegameSession): void {
		if (session == null) {
			throw new Error("Session must not be null");

		}

		this.session.Update(session);
		this.ApplySession();
		
	}

	protected WinInterrupt(): void {		
	}

	protected ApplySession() {
		this.SetTextCanvas(this.session.played.toString(), this.canvasFreegamesPlayedValue, this.statsFontHeight);
		this.SetTextCanvas(this.session.left.toString(), this.canvasfreegamesLeftValue, this.statsFontHeight);				
	}

	public Stop() {
		//Stops Anims
		this.spinsRemainingBackgroundSprite.Stop();
		this.spinsPlayedBackgroundSprite.Stop();
		this.BonusWinSprite.Stop();
		this.winConuntFrameSprite.Stop()
	}

	protected ShowWin(session: FreegameSession)
	{
		this.session.Update(session);
		TweenLite.fromTo(this.containerfreegameStats,1,{autoAlpha:0,display:"none"},{autoAlpha:1});		
		TweenLite.fromTo(this.titleElement,1,{autoAlpha:0,display:"none"},{autoAlpha:1});
		TweenLite.fromTo(this.titleFreeGameContainer,1,{autoAlpha:0,display:"none"},{autoAlpha:1});
		TweenLite.fromTo(this.finalWinContainer, 2.5, {
			x: this.viewSize.Width, display:"block",
		}, {
			x: Scale.X(0),  ease: Elastic.easeOut.config(0.50, 0.4)
		});
		this.winConuntFrameSprite.Start(true);
		this.BonusWinSprite.Start(true);
		this.SetTextCanvas(this.moneyFormatter.FormatCurrency(this.session.totalWin),this.winCanvasShow,this.winFontHeight);

	}
	
	protected ResetShowWin(session:FreegameSession) {		
		TweenLite.to(this.finalWinContainer, 2.5, {
			x: this.viewSize.Width, display: "none",
		});	
		//Stops Anims
		this.Stop();
		this.containerfreegameStats.style.display="flex";
		if(this.titleElement != null) this.titleElement.style.display="flex";
		if(this.titleFreeGameContainer != null) this.titleFreeGameContainer.style.display="flex";
	}
}

export interface IFreegameBonusFactory2 {
	CreateFreegameBonus2(gameName: ResourceIdentifier, freeGameConfig: FreegamesCommonConfiguration, params: FreegameBonus2Params): FreegameBonus2;
}

export class FreegameBonusFactory2 implements IFreegameBonusFactory2 
{

	public CreateFreegameBonus2(gameName: ResourceIdentifier, freeGameConfig: FreegamesCommonConfiguration, params: FreegameBonus2Params): FreegameBonus2 {
		return new FreegameBonus2(gameName, freeGameConfig, params);
	}
	
}